// components/PageBreadcrumbs.tsx
import React from "react";
import { Breadcrumbs, Anchor } from "@mantine/core";

// Define a breadcrumb type
export interface Crumb {
  title: string;
  href: string;
}

// Props for the component
export interface PageBreadcrumbsProps {
  crumbs?: ReadonlyArray<Crumb>;
}

// Functional component with full type safety
const PageBreadcrumbs = ({ crumbs }: PageBreadcrumbsProps): React.ReactElement | null => {
  if (!crumbs || crumbs.length <= 1) return null;

  const items = crumbs.map(({ title, href }: Crumb) => (
    <Anchor href={href} key={href} rel="noopener noreferrer">
      {title}
    </Anchor>
  ));

  return <Breadcrumbs>{items}</Breadcrumbs>;
};

export default PageBreadcrumbs;
